import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SEND_POLL_ANSWER = 'DISABLE_FORMS :: SEND_POLL_ANSWER';

export type TPollAction = IReduxAction<typeof SEND_POLL_ANSWER, string[]>;

export const sendPollAnswer = actionGenerator<typeof SEND_POLL_ANSWER, string[]>(SEND_POLL_ANSWER);
